import Const from 'constants';

const LineGroups = {
    setLineGroupsFromStorage(lineGroups) {
        return (dispatch) => {
            dispatch(this.setLineGroups(lineGroups, {countPlayers: false, saveToStorage: false}));
        };
    },
    
    setLineGroups(lineGroups, options = {}) {
        return (dispatch) => {
            const {countPlayers = true, saveToStorage = true} = options;

            dispatch({
                type: Const.SET_LINE_GROUPS,
                lineGroups: lineGroups,
            });

            dispatch({
                type: Const.EXCLUDE_PLAYERS_NOT_IN_LINE_GROUPS,
                lineGroups: lineGroups,
            });

            countPlayers && dispatch(this.setPlayersCounters());

            saveToStorage && dispatch(
                this.saveDataToStorage('lineGroups', function (state) {
                    const {lineGroupFilter} = state.playersData;

                    return lineGroupFilter.lineGroups;
                }),
            );
        };
    },
};

export default LineGroups;
